import { ChangeDetectionStrategy, Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ActionPreviewDeepLinkSection } from '../../../../../services/gable/gable.service';

/**
 * `deep_link` section — a single routerLink line ("Open the full request")
 * with a launch icon, letting the user jump to the underlying record before
 * confirming the action. Non-editable.
 */
@Component({
    selector: 'app-ap-deep-link-section',
    templateUrl: './deep-link-section.component.html',
    styleUrls: ['./deep-link-section.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ActionPreviewDeepLinkSectionComponent {
    @Input({ required: true }) section!: ActionPreviewDeepLinkSection;
}
